import {
  ServerSideFilterer,
  PageableDataSource,
  PagingSuccessResult,
  GetDataParameters,
  SortModel
} from "./table-paging";
import { FilterableColumn } from "./table-filter-select";
import { MultiSelectItem } from "../multi-select/multi-select";

export class SampleTablePager {
  /* tslint:disable */
  public pagedData: any = {
    "@odata.context": "http://services.odata.org/TripPinRESTierService/(S(wdpyzm1yze05ljf4kxobxq1r))/$metadata#People",
    value: [
      {
        UserName: "angelhuffman",
        FirstName: "Angel",
        LastName: "Huffman",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Angel@example.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "clydeguess",
        FirstName: "Clyde",
        LastName: "Guess",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: [],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [],
        HomeAddress: { Address: null, City: null }
      },
      {
        UserName: "elainestewart",
        FirstName: "Elaine",
        LastName: "Stewart",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Elaine@example.com", "Elaine@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        "@odata.type": "#Microsoft.OData.Service.Sample.TrippinInMemory.Models.Manager",
        UserName: "genevievereeves",
        FirstName: "Genevieve",
        LastName: "Reeves",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Genevieve@example.com", "Genevieve@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        Budget: 0,
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          }
        ],
        HomeAddress: null,
        BossOffice: null
      },
      {
        UserName: "georginabarlow",
        FirstName: "Georgina",
        LastName: "Barlow",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Georgina@example.com", "Georgina@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "javieralfred",
        FirstName: "Javier",
        LastName: "Alfred",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Javier@example.com", "Javier@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          {
            Address: "89 Jefferson Way Suite 2",
            City: { Name: "Portland", CountryRegion: "United States", Region: "WA" }
          }
        ],
        HomeAddress: null
      },
      {
        UserName: "jonirosales",
        FirstName: "Joni",
        LastName: "Rosales",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Joni@example.com", "Joni@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "keithpinckney",
        FirstName: "Keith",
        LastName: "Pinckney",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Keith@example.com", "Keith@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        "@odata.type": "#Microsoft.OData.Service.Sample.TrippinInMemory.Models.Employee",
        UserName: "kristakemp",
        FirstName: "Krista",
        LastName: "Kemp",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Krista@example.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        Cost: 0,
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          }
        ],
        HomeAddress: null
      },
      {
        UserName: "laurelosborn",
        FirstName: "Laurel",
        LastName: "Osborn",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Laurel@example.com", "Laurel@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          }
        ],
        HomeAddress: null
      },
      {
        UserName: "marshallgaray",
        FirstName: "Marshall",
        LastName: "Garay",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Marshall@example.com", "Marshall@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "ronaldmundy",
        FirstName: "Ronald",
        LastName: "Mundy",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Ronald@example.com", "Ronald@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "187 Suffolk Ln.", City: { Name: "Boise", CountryRegion: "United States", Region: "ID" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "russellwhyte",
        FirstName: "Russell",
        LastName: "Whyte",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Russell@example.com", "Russell@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: ["Feature1", "Feature2"],
        AddressInfo: [
          { Address: "187 Suffolk Ln.", City: { Name: "Boise", CountryRegion: "United States", Region: "ID" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "ryantheriault",
        FirstName: "Ryan",
        LastName: "Theriault",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Ryan@example.com", "Ryan@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "salliesampson",
        FirstName: "Sallie",
        LastName: "Sampson",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Sallie@example.com", "Sallie@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          },
          { Address: "89 Chiaroscuro Rd.", City: { Name: "Portland", CountryRegion: "United States", Region: "OR" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "sandyosborn",
        FirstName: "Sandy",
        LastName: "Osborn",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Sandy@example.com", "Sandy@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          }
        ],
        HomeAddress: null
      },
      {
        UserName: "scottketchum",
        FirstName: "Scott",
        LastName: "Ketchum",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Scott@example.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "2817 Milton Dr.", City: { Name: "Albuquerque", CountryRegion: "United States", Region: "NM" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "ursulabright",
        FirstName: "Ursula",
        LastName: "Bright",
        MiddleName: <string>null,
        Gender: "Female",
        Age: null,
        Emails: ["Ursula@example.com", "Ursula@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          {
            Address: "87 Polk St. Suite 5",
            City: { Name: "San Francisco", CountryRegion: "United States", Region: "CA" }
          }
        ],
        HomeAddress: null
      },
      {
        UserName: "vincentcalabrese",
        FirstName: "Vincent",
        LastName: "Calabrese",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: ["Vincent@example.com", "Vincent@contoso.com"],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [
          { Address: "55 Grizzly Peak Rd.", City: { Name: "Butte", CountryRegion: "United States", Region: "MT" } }
        ],
        HomeAddress: null
      },
      {
        UserName: "willieashmore",
        FirstName: "Willie",
        LastName: "Ashmore",
        MiddleName: <string>null,
        Gender: "Male",
        Age: null,
        Emails: [],
        FavoriteFeature: "Feature1",
        Features: [],
        AddressInfo: [],
        HomeAddress: null
      }
    ]
  };
  /* tslint:enable */
  public pageableDataSource: PageableDataSource;
  public genderStringFilterer: ServerSideFilterer;

  constructor(private extendThisTableHarness: any) {
    while (this.pagedData.value.length < 80) {
      this.pagedData.value = this.pagedData.value.concat(angular.copy(this.pagedData.value));
    }

    this.pagedData.value.forEach((item: any, index: number) => {
      item.id = index;
    });

    this.resetPageableDataSource();
    extendThisTableHarness.resetPageableDataSource = this.resetPageableDataSource.bind(this);
    extendThisTableHarness.genderStringFilterer = this.genderStringFilterer;
    extendThisTableHarness.pageableIdFetcher = this.pageableIdFetcher;
  }

  public resetPageableDataSource() {
    this.pageableDataSource = {
      getData: (arg: GetDataParameters) => {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve();
          }, 5000);
        }).then(() => {
          let callback = this.processPagedData(arg);
          return <PagingSuccessResult>{
            pageOfData: callback.dataSlice
          };
        });
      },
      allowServerFiltering: true,
      allowServerSorting: true,
      pageSize: 9
    };
    this.genderStringFilterer = new GenderStringFilterer();
    this.extendThisTableHarness.pageableDataSource = this.pageableDataSource;
  }

  private pageableIdFetcher(data: any) {
    return data.id;
  }

  private processPagedData(tableGetDataArg: GetDataParameters) {
    let filterKeys = Object.keys(tableGetDataArg.filterModel);
    let filteredData = this.pagedData.value.filter((x: any) => {
      let includeData = true;
      filterKeys.forEach((key) => {
        let filterModel = tableGetDataArg.filterModel[key];
        let oneFilterMatches = false;
        filterModel.validValues.forEach((eachFilter: string) => {
          oneFilterMatches = oneFilterMatches || x[key].toLowerCase() == eachFilter.toLowerCase();
        });

        includeData = includeData && oneFilterMatches;
      });
      return includeData;
    });

    filteredData = filteredData || [];
    tableGetDataArg.sortModel.sorts.forEach((sortModel: SortModel, index: number) => {
      let columnName = sortModel.columnName;
      let isAscending = sortModel.isAscending;
      if (index == 0) {
        filteredData = filteredData.sort((a: any, b: any) => {
          if (a[columnName] < b[columnName]) {
            return isAscending ? -1 : 1;
          } else if (a[columnName] == b[columnName]) {
            return 0;
          }
          return isAscending ? 1 : -1;
        });
      }
    });

    let endRow = tableGetDataArg.endIndex > filteredData.length ? filteredData.length - 1 : undefined;
    if (Number.isFinite(endRow) && endRow < 0) {
      endRow = 0;
    }

    let dataSlice = filteredData.slice(tableGetDataArg.startIndex, tableGetDataArg.endIndex);
    return {
      dataSlice: dataSlice,
      endRow: endRow
    };
  }
}

class GenderStringFilterer implements ServerSideFilterer {
  private filterOptions = {
    Male: {
      displayName: "Male",
      isSelected: false,
      value: "Male"
    },
    Female: {
      displayName: "Female",
      isSelected: false,
      value: "Female"
    }
  };

  constructor() {}

  public getFilterOptions(column: FilterableColumn): { [key: string]: MultiSelectItem } {
    return this.filterOptions;
  }

  public getSelectedFilters() {
    return Object.values(this.filterOptions)
      .filter((x) => x.isSelected)
      .map((x) => x.value);
  }
}
